"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 23",
    stroke: "#979797"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9.733 1.012c-.823-.08-.945.235-1.2 1.147-.256.912-1.397 3.566-2.204 4.917-.806 1.35-2.302 3.188-3.285 4.469-.983 1.28-1.345 1.021-2.044 1.041v7.503h1.394c.148-.045.791.154 1.93.599 1.71.666 4.229 1.282 6.21 1.282 1.981 0 5.724.224 7.501-.547 1.778-.77 1.53-1.29 1.53-1.598 0-.207-.184-.57-.551-1.093 1.099-.52 1.648-1.091 1.648-1.711 0-.62-.366-1.185-1.097-1.693.846-.47 1.268-1.077 1.268-1.823s-.534-1.303-1.601-1.672c.25-.428.372-.882.365-1.362-.01-.72-.644-1.411-2.08-1.427-1.437-.015-3.544.48-4.444.641-.9.162-2.667.14-2.748-1.544-.082-1.685 1.054-2.735 1.17-4.702.117-1.967-.94-2.348-1.762-2.427z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgThumbsUp);
var _default = exports["default"] = Memo;